import { render, staticRenderFns } from "./ol-swipe.vue?vue&type=template&id=0f85b278&scoped=true"
import script from "./ol-swipe.vue?vue&type=script&lang=js"
export * from "./ol-swipe.vue?vue&type=script&lang=js"
import style0 from "./ol-swipe.vue?vue&type=style&index=0&id=0f85b278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f85b278",
  null
  
)

export default component.exports